import { c as _c } from "react/compiler-runtime";
import { type FC, useCallback } from "react";
import Box from "@mui/material/Box";
import { IconLabelSelector } from "@/components/uis/IconLabelSelector";
import { useRouterPushWithPrefetch } from "@/hooks/utils/useRouterPushWithPrefetch";
import { signOut } from "@/utils/auth/signOut";
import { shouldDisplaySingleVersion } from "@/utils/features/shouldDisplaySingleVersion";
import styles from "./styles.module.css";
type FooterProps = {
  unloadingDockPattern: string;
};
export const Footer: FC<FooterProps> = t0 => {
  const $ = _c(6);
  const {
    unloadingDockPattern
  } = t0;
  const handleBerthSelectPush = useRouterPushWithPrefetch("/assessment/berths");
  const handleLogoutPush = useRouterPushWithPrefetch("/auth");
  let t1;
  if ($[0] !== handleLogoutPush) {
    t1 = () => {
      signOut().then(() => handleLogoutPush());
    };
    $[0] = handleLogoutPush;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClickLogout = t1;
  let t2;
  if ($[2] !== handleBerthSelectPush || $[3] !== onClickLogout || $[4] !== unloadingDockPattern) {
    t2 = <Box display="flex" flexDirection="column" alignItems="center" pb="24px">{!shouldDisplaySingleVersion(unloadingDockPattern ?? "") ? <Box onClick={onClickLogout} className={styles.link}><IconLabelSelector type="logout" customLabel={"\u30ED\u30B0\u30A2\u30A6\u30C8"} /></Box> : <Box onClick={handleBerthSelectPush} className={styles.link}><IconLabelSelector type="berth" customLabel={"\u8377\u53D7\u3051\u53E3\u9078\u629E"} /></Box>}</Box>;
    $[2] = handleBerthSelectPush;
    $[3] = onClickLogout;
    $[4] = unloadingDockPattern;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};